import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import moment from 'moment';
// import moment from 'moment-timezone'

/**
 * Generated class for the EditDatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-edit-date',
  templateUrl: 'edit-date.html',
})

export class EditDatePage {
  
  selectedDate:any;
  clientId:any;
  formattedDate:any;
  isReadyToSend: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public modalCtrl: ModalController) {
    this.clientId = this.navParams.get('clientId');
  }

  ionViewDidLoad() {
    
  }
    

  cancel() {
    this.viewCtrl.dismiss({ date: null, dismiss: 'cancel' });
  }

  onIonFocus(){
    let modal = this.modalCtrl.create('CalendarPage', {},{ cssClass: "edit-date-modal" });
    modal.onDidDismiss(item => {
      if (item) {
        //date received from calendar doesn't have time in it hence adding it to the date
        this.formattedDate = moment(item.date).format('YYYY-MM-DD') + 'T' + moment().format('hh:mm:ss.SSS') + 'Z'
        var d = moment(new Date(item.date)).format('DD-MM-YYYY');
        this.selectedDate = d
        this.isReadyToSend = true;
      }
    })
    modal.present();
  }

  saveDate(){
    this.viewCtrl.dismiss({date: this.formattedDate, dismiss:'done'});
  }
  

}



// WEBPACK FOOTER //
// ./src/pages/edit-date/edit-date.ts